import Vue from 'vue';
import Router from 'vue-router';
import core from './services/core';
import store from './store';
import VueRouter from 'vue-router';
import SettlementDetails from "./components/settlementDetails/settlementDetails.vue";
Vue.use(Router);
const router = new Router({
  base: '/resources/static/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import("./components/login/login.vue"),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import("./components/dashboard/dashboard.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/txnHisCC',
      name: 'txnHisCC',
      component: () => import("./components/txnHistoryCC/txnHistoryCC.vue"),
      meta: {
        requiresAuth: true
      }

      //beforeEnter: checkLoggedIn
    },
    {
      path: '/txnHisCD',
      name: 'txnHisCD',
      component: () => import("./components/txnHistoryCD/txnHistoryCD.vue"),
      meta: {
        requiresAuth: true
      }

      //beforeEnter: checkLoggedIn
    },
    {
      path: '/txnHisCLCM',
      name: 'txnHisCLCM',
      component: () => import("./components/txnHistoryCLCM/txnHistoryCLCM.vue"),
      meta: {
        requiresAuth: true
      }

      //beforeEnter: checkLoggedIn
    },
    {
      path: '/settlements',
      name: 'settlements',
      component: SettlementDetails,//() => import("./components/settlementDetails/settlementDetails.vue"),
      meta: {
        requiresAuth: true
      }
      //beforeEnter: checkLoggedIn
    },
    {
      path: '/transInfo',
      name: 'transInfo',
      component: () => import("./components/transactionInfo/transactionInfo.vue"),
      meta: {
        requiresAuth: true
      }
      //beforeEnter: checkLoggedIn
    },
    {
      path: '/fgPass',
      name: 'fgPass',
      component: () => import("./components/fgPass/fgPass.vue"),
    },
    {
      path: '/srStatusCD',
      name: 'srStatusCD',
      component: () => import("./components/srStatusCD/srStatusCD.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/srStatusCLCM',
      name: 'srStatusCLCM',
      component: () => import("./components/srStatusCLCM/srStatusCLCM.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/viewSr',
      name: 'viewSr',
      component: () => import("./components/viewSr/viewSr.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uploadCd',
      name: 'uploadCd',
      component: () => import("./components/uploadCD/uploadCD.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uploadMaster',
      name: 'uploadMaster',
      component: () => import("./components/uploadMaster/uploadMaster.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/manageUser',
      name: 'manageUser',
      component: () => import("./components/userManagement/manageUser/manageUser.vue"),
      meta: {
        requiresAuth: true
      }

      //beforeEnter: checkLoggedIn
    },
    {
      path: '/createUser',
      name: 'createUser',
      component: () => import("./components/userManagement/manageUser/createUser/createUser.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/editUser',
      name: 'editUser',
      component: () => import("./components/userManagement/manageUser/editUser/editUser.vue"),
      meta: {
        requiresAuth: true
      }
    },
        {
      path: '/uploadcomm',
      name: 'uploadcomm',
      component: () => import("./components/commission/uploadcomm.vue"),
      meta: {
        requiresAuth: true
      }
    },
        {
      path: '/transhistory',
      name: 'transhistory',
      component: () => import("./components/commission/transhistory.vue"),
      meta: {
        requiresAuth: true
      }
    }

  ],
  scrollBehavior(to, from, savedPosition) {

    return { x: 0, y: 0 }
  }
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoginGet) {
      checkLoggedIn(to, from, next, true)
    } else {
      next({ name: 'login' })
    }
  } else if (store.getters.isLoginGet) {
    checkLoggedIn(to, from, next, false)
  } else if (to.name == 'login' || to.name == 'fgPass' || to.name == 'dashboard') {
    next();
  } else {
    next({ name: 'login' })
  }
})
router.onError(error => {
  console.log(error);
})

function checkLoggedIn(to, from, next, noLogin) {
  if (noLogin) {
    next();
    return;
  } else {
    let totalModule = store.getters.staticDataGet.payload.ccSearchModule.concat(store.getters.staticDataGet.payload.cdSearchModule);
    let moduleSelected = {};
    let client = [];
    if (totalModule.length == 1) {
      moduleSelected = { name: totalModule[0]['displayName'], value: totalModule[0]['value'] };

      client = totalModule.filter(el => {
        return el.value == moduleSelected['value']
      })
    }
    let request = {
      requestModule: store.getters.sessLoginDataGet.requestModule ? store.getters.sessLoginDataGet.requestModule : "CMS",
      token: store.getters.sessLoginDataGet.sessionId,
      requestType: "WEB",
      merchantClientId: store.getters.sessLoginDataGet.clientId,
      requestFor: totalModule.length > 1 ? 'INFO' : 'DASH',
      aggId: client && client.length > 0 ? client[0]['agg_id'] : '',
      finoClientId: moduleSelected['value'] ? moduleSelected['value'] : ''
    };
    core
      .post({
        data: request,
        url: 'superinitWeb',
        method: 'post'
      })
      .then(response => {
        store.dispatch('updateIsLoginAc', true);
        store.dispatch('updateSuperInitDataAc', response);
        next({ name: 'dashboard' })
      })
      .catch(error => {
      });
  }
}
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;


